import { VFC, useMemo } from 'react';
import { REF_CURRENT_VALUES, RefCurrent, UNIT_TRANSLATED, Unit } from '@enmon/commons';
import { useIntl } from 'react-intl';
import { Select } from '../../Select';
import { useMeterModelSuggestionsStore } from '../../../../store/useMeterModelSuggestionsStore';
import { getSelectOptionsWithSuggestions } from '../../utils/getSelectOptionsWithSuggestions';

interface RefCurrentSelectProps {
  value?: RefCurrent;
  onChange?: (value: RefCurrent) => void;
}

export const RefCurrentSelect: VFC<RefCurrentSelectProps> = ({ ...restProps }: RefCurrentSelectProps) => {
  const intl = useIntl();
  const { meterModelSuggestions } = useMeterModelSuggestionsStore();

  const refCurrentOptions = useMemo(
    () =>
      getSelectOptionsWithSuggestions({
        intl,
        values: REF_CURRENT_VALUES,
        suggestedValue: meterModelSuggestions?.iRef?.value,
        suggestedSelection: meterModelSuggestions?.iRef?.selection,
      }),
    [intl, meterModelSuggestions],
  );

  return (
    <Select
      allowClear
      showArrow
      className="w-100"
      options={refCurrentOptions}
      placeholder={RefCurrent['RefCurrent-100']}
      suffix={UNIT_TRANSLATED[Unit.A]}
      {...restProps}
    />
  );
};
